<template>
    <div class="relative flex flex-col gap-5">
        <div class="flex justify-between items-center">
            <div class="text-lg font-semibold">
                {{ $t('bestPrice.modalTitle') }}
            </div>
            <form method="dialog">
                <button type="submit" class="btn btn-sm btn-circle btn-ghost">
                    <MiscIcon name="x" />
                    <span class="sr-only">{{ $t('bestPrice.modalClose') }}</span>
                </button>
            </form>
        </div>

        <ProductListingCard
            v-if="product"
            :data="product"
            direction="horizontal"
        />

        <p class="font-bold" v-text="$t('bestPrice.infoText1')" />

        <div>
            <span v-text="$t('bestPrice.infoText2')" /> <MiscLink class="link font-bold" :to="$t('bestPrice.infoLinkTarget')">
                ({{ $t('bestPrice.infoLinkText') }})
            </MiscLink>
        </div>

        <div v-if="cmsContent != null" class="w-full">
            <StructurePage
                v-if="cmsContent"
                :content="cmsContent"
            />
        </div>
        <div v-else class="w-full shrink-0 gap-4">
            <MiscSkeleton :repeat="5" size="large" />
        </div>
    </div>
</template>

<script setup lang="ts">
const { product } = useProduct()
const { apiClient } = useShopwareContext()
const config = useRuntimeConfig().public
const loading = ref(false)
const cmsContent = ref()

onMounted(() => {
    fetchCms()
})

async function fetchCms () {
    if (config.bestPriceCms == null || config.bestPriceCms.trim() === '') {
        return
    }

    loading.value = true
    const { data } = await apiClient.invoke('readCms post /cms/{id}', {
        pathParams: {
            id: config.bestPriceCms
        }, 
        body: {
            associations: {
                media: {}
            }
        }
    })

    cmsContent.value = data
    loading.value = false
}
</script>
